import { z } from 'zod';
import { $secureTokenOptionsSchema, SecureTokenOptions } from './secure-token';

export interface SsoConfigAttributes {
  id: number;
  accountId: string;
  programId: string | null;
  cookieDuration?: number | null;
  secureToken?: SecureTokenOptions | null;
  clientId: string;
  clientSecret: string;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date | null;
}

export const $setSsoConfigBody = z.object({
  secureToken: $secureTokenOptionsSchema.optional(),
  cookieDuration: z.number().optional(),
  clientId: z.string().optional(),
  clientSecret: z.string().optional(),
});
export type SetSsoConfigBody = z.infer<typeof $setSsoConfigBody>;

export const $setSsoConfigQuery = z.object({ programId: z.string().optional() });
export type SetSsoConfigQuery = z.infer<typeof $setSsoConfigQuery>;
